import { render, staticRenderFns } from "./TipoCliente.vue?vue&type=template&id=51820a72&scoped=true"
import script from "./TipoCliente.vue?vue&type=script&lang=ts"
export * from "./TipoCliente.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51820a72",
  null
  
)

export default component.exports